import createIcon from '../../createIcon';

/**
 * @component @name QuestionMark
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTEuMDY5MSAxMi4zNUMxMS44MzkxIDEwLjk2IDEzLjMxOTEgMTAuMTQgMTQuMTc5MSA4LjkxQzE1LjA4OTEgNy42MiAxNC41NzkxIDUuMjEgMTEuOTk5MSA1LjIxQzEwLjMwOTEgNS4yMSA5LjQ3OTA2IDYuNDkgOS4xMjkwNiA3LjU1TDYuNTM5MDYgNi40NkM3LjI0OTA2IDQuMzMgOS4xNzkwNiAyLjUgMTEuOTg5MSAyLjVDMTQuMzM5MSAyLjUgMTUuOTQ5MSAzLjU3IDE2Ljc2OTEgNC45MUMxNy40NjkxIDYuMDYgMTcuODc5MSA4LjIxIDE2Ljc5OTEgOS44MUMxNS41OTkxIDExLjU4IDE0LjQ0OTEgMTIuMTIgMTMuODI5MSAxMy4yNkMxMy41NzkxIDEzLjcyIDEzLjQ3OTEgMTQuMDIgMTMuNDc5MSAxNS41SDEwLjU4OTFDMTAuNTc5MSAxNC43MiAxMC40NTkxIDEzLjQ1IDExLjA2OTEgMTIuMzVaTTEzLjk5OTEgMTkuNUMxMy45OTkxIDIwLjYgMTMuMDk5MSAyMS41IDExLjk5OTEgMjEuNUMxMC44OTkxIDIxLjUgOS45OTkwNiAyMC42IDkuOTk5MDYgMTkuNUM5Ljk5OTA2IDE4LjQgMTAuODk5MSAxNy41IDExLjk5OTEgMTcuNUMxMy4wOTkxIDE3LjUgMTMuOTk5MSAxOC40IDEzLjk5OTEgMTkuNVoiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const QuestionMark = createIcon('QuestionMark', [
  [
    'path',
    {
      d: 'M11.0691 12.35C11.8391 10.96 13.3191 10.14 14.1791 8.91C15.0891 7.62 14.5791 5.21 11.9991 5.21C10.3091 5.21 9.47906 6.49 9.12906 7.55L6.53906 6.46C7.24906 4.33 9.17906 2.5 11.9891 2.5C14.3391 2.5 15.9491 3.57 16.7691 4.91C17.4691 6.06 17.8791 8.21 16.7991 9.81C15.5991 11.58 14.4491 12.12 13.8291 13.26C13.5791 13.72 13.4791 14.02 13.4791 15.5H10.5891C10.5791 14.72 10.4591 13.45 11.0691 12.35ZM13.9991 19.5C13.9991 20.6 13.0991 21.5 11.9991 21.5C10.8991 21.5 9.99906 20.6 9.99906 19.5C9.99906 18.4 10.8991 17.5 11.9991 17.5C13.0991 17.5 13.9991 18.4 13.9991 19.5Z',
      key: 'pivrc5',
    },
  ],
]);

export default QuestionMark;
